import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesNotificationEditRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-notification-edit',
	path: '/secure/admin/EditNotifications([!%]?[\\w]*).jspa',
};
